import { Map as ImmutableMap } from 'immutable';
import { createAction } from 'redux-actions';

import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';

import { ImportModalComponent } from 'components/RootModal/modalRegistry';

export const INVOICE_FORM_ROOTUI_TYPE = 'INVOICE_FORM_DIALOG';
// The invoice form renders its own full-screen StdDialog (pinned to the drawer
// plane via getInvoiceFormDialogSx), so it must never be promoted to an overlay
// drawer shell when launched from a drawer — that shell would render empty and
// still push a left edge over the invoice. Keep it on the modal presentation path.
ImportModalComponent(INVOICE_FORM_ROOTUI_TYPE, () => import('./index'), { rootModalPresentation: 'modal' });

// @ts-expect-error FIXME TS7006
export const InvoiceFormUpsertAction = createAction(rootUiActions.createDialog.toString(), (props) =>
  rootUiTypes.mkRootUiData({
    type: INVOICE_FORM_ROOTUI_TYPE,
    props: ImmutableMap({
      blankInvoice: props.blankInvoice ?? false,
      context: props.context,
      customerId: props.customerId ?? '',
      initialView: props.initialView ?? 'Edit',
      projectId: props.projectId ?? '',
      subtype: props.subtype,
      titleProp: props.titleProp ?? 'Invoice',
      invoiceId: props.invoiceId,
    }),
  }),
);
